import { PlantsEnum, SubPlantCodesEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { GrnItems } from "./raw-material-grn-items.entity";
import { Grn } from "./raw-material-grn.entity";
@Entity('grn_item_defects')
export class GrnItemDefects {

    @PrimaryGeneratedColumn("increment", { name: 'grn_item__defects_id' })
    grnItemDefectsId: number;
    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'grn_item_id'
    })
    grnItemId: number;


    @Column("int", {
        nullable: false,
        name: "indent_id"
    })
    indentId: number;
    @Column("int", {
        nullable: false,
        name: "indent_item_id"
    })
    indentItemId: number;



    @Column("int", {
        nullable: true,
        name: "defect_id"
    })
    defectId: number;
    @Column("int", {
        nullable: false,
        name: "percentage"
    })
    percentage: number;

    @Column("decimal", {
        nullable: false,
        name: "quantity",
        precision:10,scale:3,
        unsigned:true,
    })
    quantity: number;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "is_new_item"
    })
    isNewItem: boolean;


    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => GrnItems, grnItems => grnItems.grnItemDefects, { nullable: false, })
    @JoinColumn({ name: "grn_item_id" })
    grnItemsInfo: GrnItems;


}
